import {
      Dialog,
      DialogTitle,
      DialogContent,
      DialogContentText,
      DialogActions,
      Button,
} from "@mui/material";



const TruInkUpdateTagModel = ({
      open,
      text,
      onSubmit,
      onCancel,
      buttonText1,
      buttonText2,
}) => {
      return (
            <Dialog
                  open={open}
                  onClose={onCancel}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
            >
                  <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
                  <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                              {text}
                        </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                        <Button onClick={onCancel} color="warning">
                              {buttonText1}
                        </Button>
                        <Button onClick={onSubmit} variant="contained" color="success" autoFocus>
                              {buttonText2}
                        </Button>
                  </DialogActions>
            </Dialog>
      );
};

export default TruInkUpdateTagModel;
